import React, { useEffect, useState } from 'react';
import { useLastTrucking } from '../../../../../../Hooks/TT_ELD/Logs';
import { Button, Card, Descriptions, Spin, Tag } from 'antd';
import moment from 'moment';
import { useParams } from 'react-router-dom';

interface DescriptionItem {
  label: string;
  value: any;
}

const LastTracking = () => {
  const { id } = useParams<{ id: string }>();
  const { data, refetch, isLoading, isFetching } = useLastTrucking(id);
  const [parsedData, setParsedData] = useState<any>(null);

  useEffect(() => {
    const debugInfo = data?.data?.debug_info;

    if (!debugInfo || typeof debugInfo !== 'string') {
      setParsedData(null);
      return;
    }

    try {
      const parsed = JSON.parse(debugInfo);
      // Убедимся, что это реально объект, а не что-то вроде массива
      if (typeof parsed === 'object' && !Array.isArray(parsed)) {
        setParsedData(parsed);
      } else {
        setParsedData(null);
      }
    } catch (e) {
      // Не валидный JSON — игнорируем
      setParsedData(null);
    }
  }, [data]);

  const time = moment.utc(data?.data?.date || '').format('YYYY-MM-DD, h:mm:ss A (UTCZ)');

  const items1: DescriptionItem[] = [
    { label: 'Rotation', value: data?.data?.rotation },
    { label: 'Speed', value: data?.data?.speed },
    { label: 'Delta Distance', value: data?.data?.delta_distance },
    { label: 'Engine Hours', value: data?.data?.engine_hours },
    { label: 'State', value: data?.data?.state },
    { label: 'Odometer', value: data?.data?.odometr },
    { label: 'Source', value: data?.data?.source },
    { label: 'Time', value: time },
    { label: 'Is Live', value: data?.data?.is_live },
    { label: 'Latitude', value: data?.data?.coordinates?.lat },
    { label: 'Longitude', value: data?.data?.coordinates?.lng },
  ];

  const generateDebugItems = (data: any): DescriptionItem[] => {
    if (!data) return [];

    const items: DescriptionItem[] = [];

    const flattenObject = (obj: any, prefix: string = '') => {
      Object.entries(obj).forEach(([key, value]) => {
        const label = prefix
          ? `${prefix} ${key.replace(/([A-Z])/g, ' $1').trim()}`
          : key
              .replace(/([A-Z])/g, ' $1')
              .replace(/^./, (str) => str.toUpperCase())
              .trim();

        if (value && typeof value === 'object' && !Array.isArray(value)) {
          flattenObject(value, label);
        } else {
          items.push({ label, value });
        }
      });
    };

    flattenObject(data);
    return items;
  };

  // Determine the info tag (e.g., PT 30, IOSiX, etc.)
  const info = parsedData?.pt30
    ? '( PT 30 )'
    : parsedData?.iosIx
    ? '( IOSiX )'
    : parsedData?.protrux
    ? '( ProTrux )'
    : parsedData?.jimi
    ? '( ProTrux )'
    : '';

  const renderValue = (value: any) => {
    if (typeof value === 'boolean') {
      return <Tag color={value ? 'geekblue' : 'red'}>{value ? 'True' : 'False'}</Tag>;
    }
    return value ?? 'N/A';
  };

  return (
    <div>
      <Spin size="large" spinning={isLoading || isFetching}>
        <Card
          extra={
            <Button style={{ marginLeft: 'auto' }} size="large" onClick={() => refetch()}>
              Refresh
            </Button>
          }
        >
          <Descriptions title="Tracking" bordered>
            {items1.map((item, index) => (
              <Descriptions.Item key={index} label={item.label}>
                {renderValue(item.value)}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Card>
        <Card style={{ marginTop: '10px' }}>
          {parsedData ? (
            <Descriptions title={`Debug Info ${info}`} bordered>
              {generateDebugItems(parsedData).map((item, index) => (
                <Descriptions.Item key={index} label={item.label}>
                  {renderValue(item.value)}
                </Descriptions.Item>
              ))}
            </Descriptions>
          ) : (
            <Descriptions title="Debug Info" bordered>
              <Descriptions.Item label="Info">No data</Descriptions.Item>
            </Descriptions>
          )}
        </Card>

        {!parsedData && <Card>{JSON.stringify(data?.data?.debug_info)}</Card>}
      </Spin>
    </div>
  );
};

export default LastTracking;
